var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMoney = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.166626C8.27614 0.166626 8.5 0.390484 8.5 0.666626V15.3333C8.5 15.6094 8.27614 15.8333 8 15.8333C7.72386 15.8333 7.5 15.6094 7.5 15.3333V0.666626C7.5 0.390484 7.72386 0.166626 8 0.166626Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32986 3.66324C4.86122 3.13189 5.58189 2.83337 6.33333 2.83337H11.3333C11.6095 2.83337 11.8333 3.05723 11.8333 3.33337C11.8333 3.60952 11.6095 3.83337 11.3333 3.83337H6.33333C5.8471 3.83337 5.38079 4.02653 5.03697 4.37035C4.69315 4.71416 4.5 5.18048 4.5 5.66671C4.5 6.15294 4.69315 6.61925 5.03697 6.96307C5.38079 7.30689 5.8471 7.50004 6.33333 7.50004H9.66667C10.4181 7.50004 11.1388 7.79855 11.6701 8.32991C12.2015 8.86126 12.5 9.58193 12.5 10.3334C12.5 11.0848 12.2015 11.8055 11.6701 12.3368C11.1388 12.8682 10.4181 13.1667 9.66667 13.1667H4C3.72386 13.1667 3.5 12.9429 3.5 12.6667C3.5 12.3906 3.72386 12.1667 4 12.1667H9.66667C10.1529 12.1667 10.6192 11.9736 10.963 11.6297C11.3068 11.2859 11.5 10.8196 11.5 10.3334C11.5 9.84714 11.3068 9.38083 10.963 9.03701C10.6192 8.6932 10.1529 8.50004 9.66667 8.50004H6.33333C5.58189 8.50004 4.86122 8.20153 4.32986 7.67018C3.79851 7.13882 3.5 6.41815 3.5 5.66671C3.5 4.91526 3.79851 4.19459 4.32986 3.66324Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoney, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/money.d81d726a.svg";
export { ForwardRef as ReactComponent };